"use client";

import { useState, useEffect, useCallback, useRef } from "react";
import { KbvPluginService } from "@/services/kbvPluginService";

export default function useHotLeagues({ limit = 20 } = {}) {
  const [leagues, setLeagues] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const loadMoreRef = useRef(null);
  const isLoadingMoreRef = useRef(false);

  useEffect(() => {
    const fetchInitial = async () => {
      try {
        setLoading(true);
        const data = await KbvPluginService.getHotLeagues({
          page: 1,
          limit,
          fields: "id,name,logo,slug,nameVN",
        });
        setLeagues(data);
        setPage(1);
      } catch (error) {
        console.error("Error fetching hot leagues:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitial();
  }, [limit]);

  const loadMore = useCallback(async () => {
    if (isLoadingMoreRef.current) return;

    isLoadingMoreRef.current = true;
    const nextPage = page + 1;

    const data = await KbvPluginService.getHotLeagues({
      page: nextPage,
      limit,
    });

    if (data.length) {
      setLeagues((prev) => [...prev, ...data]);
      setPage(nextPage);
    }

    isLoadingMoreRef.current = false;
  }, [page, limit]);

  return {
    leagues,
    loading,
    loadMore,
    loadMoreRef,
  };
}
